export enum SubscriptionTypeEnum {
  AffiliateMember = 1,
  ActiveMember = 2
}
